import React from 'react';

import { Modal, Switch, Input, Form } from 'antd';
import { NotificationInstance } from 'antd/lib/notification/interface';

import IBaseComponentProps from '@components/base-component-props';

import { exception } from '@extensions/notification';

import { userLoaded } from '@store/actions';
import { useAppDispatch } from '@store/hooks';

import { ICounterparty } from '@core/entities/counterparty';

interface ICounterpartyProps extends IBaseComponentProps {
    counterparty: ICounterparty;
    isViewOnly: boolean;
    onClose: (refreshRequired: boolean) => void;
    api: NotificationInstance;
}

const Counterparty = (props: ICounterpartyProps) => {
    const { counterparty, isViewOnly, api, onClose, serverFetch } = props;

    const { TextArea } = Input;

    const [counterpartyForm] = Form.useForm();

    const d = useAppDispatch();

    const onSave = (data: ICounterparty) => {
        if (!data) return;

        serverFetch(`counterparties`, { method: data.id ? 'PUT' : 'POST', bodyData: data })
            .then(() => {
                counterpartyForm.resetFields();
                onClose(true);
            })
            .catch((ex: any) => {
                exception(api, 'Ошибка сохранения контрагента', ex, () => d(userLoaded(undefined)));
            });
    };

    return (
        <Modal
            destroyOnHidden={true}
            closable={false}
            title={counterparty.id ? 'Изменить контрагента' : 'Добавить контрагента'}
            open={true}
            okText='ОК'
            onOk={() => counterpartyForm.submit()}
            onCancel={() => {
                counterpartyForm.resetFields();
                onClose(false);
            }}
            width={500}
        >
            <Form
                preserve={false}
                colon={false}
                labelCol={{ span: 6 }}
                wrapperCol={{ span: 18 }}
                style={{ marginTop: 20 }}
                onFinish={onSave}
                form={counterpartyForm}
            >
                <Form.Item hidden name='id' initialValue={counterparty?.id}>
                    <Input />
                </Form.Item>
                <Form.Item hidden name='userId' initialValue={counterparty?.userId}>
                    <Input />
                </Form.Item>
                <Form.Item
                    initialValue={counterparty?.legalName}
                    label='Юр. имя'
                    name='legalName'
                    required={true}
                    rules={[{ required: true, message: 'Укажите юридическое имя' }]}
                >
                    <Input autoFocus disabled={isViewOnly} />
                </Form.Item>
                <Form.Item
                    label='ИНН'
                    initialValue={counterparty?.inn}
                    name='inn'
                    required={true}
                    rules={[{ required: true, message: 'Укажите ИНН' }]}
                >
                    <Input disabled={isViewOnly} />
                </Form.Item>
                <Form.Item
                    label='Юр. адрес'
                    initialValue={counterparty?.legalAddress}
                    name='legalAddress'
                    required={true}
                    rules={[{ required: true, message: 'Укажите юридический адрес' }]}
                >
                    <TextArea disabled={isViewOnly} />
                </Form.Item>
                <Form.Item label='Основной' name='IsMain' valuePropName='checked' initialValue={counterparty?.isMain}>
                    <Switch disabled={isViewOnly} />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default Counterparty;
